<div class="modal-asset-download audio-download">
  <h4 class="modal-title">Download</h4>

  <div class="main-content">
    <ion-buttons class="modal-buttons-block">
      <button *ngFor="let type of asperaTypes" ion-button (click)="onAsperaButtonClick(type)" class="modal-button">
        <span class="aspera-icon icon"></span>
        Aspera |&nbsp;<span [ngClass]="{'uppercase': type?.type !== 'All Formats'}">{{type?.type}}</span>
      </button>
    </ion-buttons>

    <ion-buttons class="modal-buttons-block">
      <ng-container *ngIf="types?.length">
        <button ion-button *ngFor="let type of types"
                (click)="downloadFileByType(type)"
                [ngClass]="{'uppercase': type?.type !== 'All Formats'}"
                class="modal-button">
          <i class="fas fa-download icon"></i>
          {{type?.type}}
        </button>
      </ng-container>
    </ion-buttons>

    <ion-buttons class="modal-buttons-block">
      <button ion-button (click)="onClose()" class="modal-button">
        <i class="far fa-times-circle icon"></i>
        Close
      </button>
    </ion-buttons>
  </div>
</div>
